import './LegalPage.css';

/**
 * Politique de Confidentialité Page
 */
export const PolitiqueConfidentialite = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-page__content">
          <h1 className="legal-page__title">Politique de Confidentialité</h1>
          
          <section className="legal-page__section">
            <h2>Introduction</h2>
            <p>
              Bookiner accorde une grande importance à la protection de vos données personnelles.
              Cette politique de confidentialité vous informe sur la manière dont nous collectons,
              utilisons et protégeons vos données dans le respect du Règlement Général sur la Protection des Données (RGPD).
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Données collectées</h2>
            <p>
              Nous collectons les données suivantes lors de votre inscription à la liste de démonstration :
            </p>
            <ul>
              <li>Adresse email (obligatoire)</li>
              <li>Prénom (optionnel)</li>
              <li>Nom (optionnel)</li>
              <li>Cas d'usage (obligatoire)</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>Finalité du traitement</h2>
            <p>
              Vos données sont collectées dans le but de :
            </p>
            <ul>
              <li>Vous tenir informé du développement de Bookiner</li>
              <li>Vous donner accès à la version de démonstration</li>
              <li>Améliorer notre service en fonction de vos besoins</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>Conservation des données</h2>
            <p>
              Vos données sont conservées pendant toute la durée du projet et jusqu'à 3 ans après votre dernière interaction
              avec nos services, sauf opposition de votre part.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Vos droits</h2>
            <p>
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul>
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification de vos données</li>
              <li>Droit à l'effacement de vos données</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité de vos données</li>
              <li>Droit d'opposition au traitement</li>
            </ul>
            <p>
              Pour exercer ces droits, contactez-nous à : contact@bookiner.co
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Sécurité</h2>
            <p>
              Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées
              pour protéger vos données contre toute destruction, perte, altération, divulgation ou accès non autorisé.
            </p>
          </section>

          <a href="/" className="legal-page__back">← Retour à l'accueil</a>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
